import styled, { css } from 'styled-components';
import { StyledRteHtmlText } from './StyledRteHtmlText';
import { StyledRteHtmlTextNoFont } from './StyledRteHtmlTextNoFont';

/**
 * Componente che renderizza un elemento senza alcun stile
 */
export const StyledRichTextAdvancedText = styled.span<{
  inline?: boolean;
  hasCustomFont?: boolean;
}>`
  &&& {
    margin-bottom: 0;
    > p {
      display: inline;
      margin-bottom: 0;
    }
    // per evitare che i paragrafi con allineamento definito nel RTE (opzione Align presente)
    // vengano visualizzati come inline-block (e senza allineamento)
    // inseriamo un display block
    // in questo caso azzeriamo anche il padding-left
    // che serviva per spostare il testo aggiunto (aggiungi testo in RTE)
    // e non farlo venire attaccato al precedente quando è inline
    // notare che text-align non viene aggiunto in caso di allineamento a sinistra
    // quindi anche in presenza opzione Align presente se impostato a left
    // non viene aggiunto il display block e il testo viene visualizzato inline-block
    // permettendo la composizione del testo a seguire
    > p[style*='text-align:'] {
      display: block;
      padding-left: 0;
    }
    // nascondiamo campo se vuoto per accessibilità
    &:empty {
      display: none;
    }

    ${props =>
      props.inline &&
      css`
        display: inline;
        margin-bottom: 0;
        p {
          display: inline;
          margin-right: 0.25em;
          margin-bottom: 0;
          &:last-child {
            margin-right: 0;
          }
        }
      `}
    ${props =>
      props.hasCustomFont
        ? css`
            ${StyledRteHtmlText}
          `
        : css`
            ${StyledRteHtmlTextNoFont}
          `}
  }
  & + & {
    // modificato selettore per non includere i figli di StyledRichTextAdvancedText
    // con il selettore display block (ul, ol, ecc.) altrimenti il padding sposta l'elemento in basso
    > p {
      // dato che il componente è uno span inseriamo uno spazio tra un elemento e l'altro
      // per evitare che vengano renderizzati attaccati
      padding-left: 0.25em;
    }
  }

  span.compute-expression-reference {
    color: ${props => props.theme.colorPrimary};
    font-weight: bold;
  }
`;
